/**
 * Rememberry - Translate and Memorize with Flashcards — translation + spaced repetition
 *
 * Declares a single web-accessible-resource entry to every origin with no
 * `use_dynamic_url`, exposing `fonts/*`, `html/auth.html` and `html/payment.html`. All
 * are reachable from any page at a fixed URL.
 *
 * No image is exposed, so the primary signal is a fetch of `html/auth.html` — a named
 * feature page — corroborated by the payment page and the `rbicon` icon font.
 *
 * Manifest verified against version 1.7.0.
 */

import { probeFetch } from '../core/probe';
import type { ExtensionDefinition } from '../core/types';

const ID = 'dipiagiiohfljcicegpgffpbnjmgjcnf';

export const rememberry: ExtensionDefinition = {
  id: ID,
  name: 'Rememberry - Translate and Memorize with Flashcards',
  storeUrl: `https://chromewebstore.google.com/detail/${ID}`,
  users: 100_000,
  notes:
    'fonts/* and two named HTML pages exposed to every origin with no dynamic URL. ' +
    'A single fetch of a named page is conclusive.',
  signals: [
    {
      id: 'war-auth-html',
      kind: 'web-accessible-resource',
      description:
        'Fetch html/auth.html — a named feature page exposed to every origin at a fixed URL.',
      weight: 1,
      run: () => probeFetch(ID, 'html/auth.html'),
    },
    {
      id: 'war-payment-html',
      kind: 'web-accessible-resource',
      description: 'Fetch html/payment.html — the payment page, corroborating the match.',
      weight: 0.5,
      run: () => probeFetch(ID, 'html/payment.html'),
    },
    {
      id: 'war-rbicon-font',
      kind: 'web-accessible-resource',
      description:
        'Fetch fonts/rbicon.woff2 — a vendor-named (rb) icon font, a third independent path.',
      weight: 0.5,
      run: () => probeFetch(ID, 'fonts/rbicon.woff2'),
    },
  ],
};
